<div class="d-flex gap-1 align-items-center">
  <span class="fs-xs">{{ description }}</span>
  <span class="details-secondary-text">{{ value }}{{ value ? unit : '' }}</span>
</div>
